import React, {Component, ReactNode} from 'react'
import ReservationCardInformation from '../ReservationCardInformation'
import ReservationsRepository from '../ReservationsRepository'
import EventEmitterExResident from '../../shared/pageBaseComponents/EventEmitterExResident'
import {NatAsyncCallFunction} from '../../../__NoAutomatedTests/common/util/Natutil'
import ReservationCard from '../components/ReservationCard'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {UnstyledLink} from '../../../styledComponents/Links'
import {CardList} from '../components/CommonStyle'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {NavigateFunction} from 'react-router-dom'

interface Props {
    condominiumCd: string
    reservationsRepo: ReservationsRepository
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
}

interface State {
    reservationsOfWaitingConfirmationExists: boolean
    futureReservations: ReservationCardInformation[]
}

class RRFTMyReservationsComponent extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            reservationsOfWaitingConfirmationExists: false,
            futureReservations: [],
        }

        this.handleClickReservationsOfWaitingConfirmationExists =
            this.handleClickReservationsOfWaitingConfirmationExists.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {condominiumCd, reservationsRepo, eventEmitter, navigate} = this.props

        await eventEmitter.showLoading()
        try {
            const reservationsOfWaitingConfirmation = await NatAsyncCallFunction(
                reservationsRepo.getReservationsOfWaitingConfirmation.bind(
                    reservationsRepo,
                    condominiumCd,
                ),
                navigate,
            )
            if (reservationsOfWaitingConfirmation === null) {
                return
            }
            this.setState({
                reservationsOfWaitingConfirmationExists:
                    reservationsOfWaitingConfirmation.reservationCardInformations.length > 0,
            })

            const futureReservations = await NatAsyncCallFunction(
                reservationsRepo.getFutureReservations.bind(
                    reservationsRepo,
                    condominiumCd,
                ),
                navigate,
            )
            if (futureReservations === null) {
                return
            }
            this.setState({futureReservations})

        } finally {
            eventEmitter.closeLoading()
        }
    }

    handleClickReservationsOfWaitingConfirmationExists(): void {
        const {condominiumCd, navigate} = this.props

        navigate(
            `/resident/condominiums/${condominiumCd}/my-reservations`,
        )
    }

    handleClickReservationCard(facilityId: number, facilityReserveId: number): void {
        const {condominiumCd, navigate} = this.props

        navigate(
            `/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reservations/${facilityReserveId}/detail`,
            {state: {previousPageUrl: `/resident/condominiums/${condominiumCd}/reserve-facility-top`}},
        )
    }

    render(): ReactNode {
        const {reservationsOfWaitingConfirmationExists, futureReservations} = this.state

        if (futureReservations.length === 0 && !reservationsOfWaitingConfirmationExists) {
            return (<>
                <BlockSpacer height={'20px'}/>
                <Message>本日以降の予約はありません</Message>
            </>)
        }

        return <>
            {
                reservationsOfWaitingConfirmationExists &&
                <>
                    <BlockSpacer height={'20px'}/>
                    <WaitingConfirmationBlock>
                        <WaitingConfirmationLink
                            to={`/resident/condominiums/${this.props.condominiumCd}/my-reservations`}
                        >
                            確定待ちの予約があります
                        </WaitingConfirmationLink>
                    </WaitingConfirmationBlock>
                </>
            }
            <CardList>
                {
                    futureReservations.map((reservation, index) => (
                        <ReservationCard
                            key={index}
                            cardInformation={reservation}
                            onClick={this.handleClickReservationCard
                                .bind(this, reservation.facilityId, reservation.facilityReserveId)}
                        />
                    ))
                }
            </CardList>
        </>
    }
}

export default RRFTMyReservationsComponent

const WaitingConfirmationBlock = styled.div`
  background-color: ${Colors.Surface};
  padding: 10px 15px 10px 10px;
`

const WaitingConfirmationLink = styled(UnstyledLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  color: ${Colors.Primary};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};

  &::before {
    content: "";
    background: linear-gradient(135deg, rgb(239, 103, 35) 50%, rgb(216, 91, 28) 50%);
    height: 30px;
    width: 30px;
    display: inline-block;
    margin-right: 10px;
  }

  &::after {
    content: '';
    width: 0.8rem;
    height: 0.8rem;
    border-top: solid 2px ${Colors.Primary};
    border-right: solid 2px ${Colors.Primary};
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    margin-left: auto;
  }
`

const Message = styled.div`
  color: ${Colors.Body};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};
`
